import { render, staticRenderFns } from "./SEGR.vue?vue&type=template&id=55c44b40&"
import script from "./SEGR.vue?vue&type=script&lang=js&"
export * from "./SEGR.vue?vue&type=script&lang=js&"
import style0 from "./SEGR.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55c44b40')) {
      api.createRecord('55c44b40', component.options)
    } else {
      api.reload('55c44b40', component.options)
    }
    module.hot.accept("./SEGR.vue?vue&type=template&id=55c44b40&", function () {
      api.rerender('55c44b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/SEGR.vue"
export default component.exports